import { Tooltip, TooltipProps } from '@mui/material';
import React from 'react';
import { Shadows } from 'theme';
import { makeStyles } from 'tss-react/mui';

interface Props {
  variant?: 'default' | 'white' | 'error';
}

const PaiTooltip: React.FC<TooltipProps & Props> = (props) => {
  const { variant = 'default' } = props;
  const { classes } = useStyles({ variant });

  return (
    <Tooltip
      {...props}
      classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
      arrow={true}
      PopperProps={{
        modifiers: [
          {
            name: 'flip',
            options: {
              fallbackPlacements: ['top', 'bottom', 'left'],
            },
          },
          {
            name: 'preventOverflow',
            options: {
              padding: 8,
            },
          },
        ],
      }}
    >
      {props.children}
    </Tooltip>
  );
};

const useStyles = makeStyles<{ variant?: 'default' | 'white' | 'error' }>()((theme, { variant }) => ({
  tooltip: {
    fontSize: theme.typography.pxToRem(13),
    background: variant === 'default' ? theme.palette.greys.lighter : variant === 'white' ? '#FFF' : variant === 'error' ? theme.palette.error.main : theme.palette.greys.lighter,
    color: variant === 'error' ? '#FFF' : theme.palette.text.primary,
    whiteSpace: 'pre-wrap',
    borderRadius: '4px',
    boxShadow: Shadows.GREY_SHADOW_LIGHTER,
    padding: variant === 'default' ? undefined : variant === 'white' || variant === 'error' ? '8px 12px' : undefined,
    maxWidth: '375px',
  },
  arrow: {
    color: variant === 'default' ? theme.palette.greys.lighter : variant === 'white' ? '#FFF' : variant === 'error' ? theme.palette.error.main : theme.palette.greys.lighter,
  },
}));

export default PaiTooltip;
